// extracted by mini-css-extract-plugin
export var divider = "_ux-0";